import styled from 'styled-components';
import MaterialButton from '@material-ui/core/Button';

const Button = styled(MaterialButton)`
  span {
    font-family: 'Montserrat', 'Open Sans', sans-serif;
    color: white;
  }
`;

export default Button;



// WEBPACK FOOTER //
// ./src/components/Button/index.js